import { UPDATE_EVENTS_FILTERS } from "./constants";

export const updateFilters = (filters) => ({
  type: UPDATE_EVENTS_FILTERS,
  filters
});
